"use client"

import { Text } from "@/elements"
import { ArrowRightIcon } from "@heroicons/react/24/outline"

import Image, { StaticImageData } from "next/image"
import { MouseParallaxChild, MouseParallaxContainer } from "react-parallax-mouse"

import fourtwofour from "@/public/marketing/hero/424.png"
import aidan from "@/public/marketing/hero/aidancullen.png"
import connor from "@/public/marketing/hero/connorcunningham.png"
import goshi from "@/public/marketing/hero/goshi.png"
import leftImage from "@/public/marketing/hero/left.jpg"
import pizzaslime from "@/public/marketing/hero/pizzaslime.png"
import rightImage from "@/public/marketing/hero/right.jpg"
import { WordCycler } from "../components/WordCycler"
import Link from "next/link"

export const HeroSection = () => {
  return (
    <>
      <section className="relative hidden h-screen w-full sm:block">
        <MouseParallaxContainer
          className="absolute inset-0"
          inverted={true}
          globalFactorX={0.1}
          globalFactorY={0.1}
          containerStyle={{
            width: "100%",
            height: "100%",
            maxWidth: "1440px",
            margin: "0 auto",
            overflow: "visible",
          }}
          resetOnLeave={false}>
          <MouseParallaxChild className="absolute -left-[80px] top-10 opacity-80" factorX={1.5} factorY={1.5}>
            <PostCard
              imageSrc={goshi}
              scale={0.8}
              name="Goshi"
              textParts={[
                { text: "Social Media Manager", isPrimary: true },
                { text: "needed in", isPrimary: false },
                { text: "Los Angeles, CA.", isPrimary: true },
                { text: "Full-time.", isPrimary: false },
              ]}
            />
          </MouseParallaxChild>
          <MouseParallaxChild
            className="absolute left-[-250px] top-60 lg:left-[-180px] xl:left-[-90px]"
            factorX={0.5}
            factorY={0.5}>
            <Image
              src={leftImage}
              alt="left"
              width={2000}
              height={2000}
              className="w-[350px] object-left opacity-100"
            />
          </MouseParallaxChild>
          <MouseParallaxChild className="absolute left-[3%] top-[68%] xl:top-[62%]">
            <PostCard
              imageSrc={connor}
              name="Conor Cunningham"
              professionString="Photographer"
              textParts={[
                { text: "Hair & Makeup Artist", isPrimary: true },
                { text: "needed in", isPrimary: false },
                { text: "Miami, FL", isPrimary: true },
                { text: "on", isPrimary: false },
                { text: "2/25.", isPrimary: true },
              ]}
            />
          </MouseParallaxChild>
          <MouseParallaxChild className="absolute bottom-[5%] left-[50%]">
            <PostCard
              imageSrc={fourtwofour}
              name="424"
              textParts={[
                { text: "Photographer", isPrimary: true },
                { text: "needed for a", isPrimary: false },
                { text: "lookbook", isPrimary: true },
                { text: "in", isPrimary: false },
                { text: "Paris", isPrimary: true },
                { text: "on", isPrimary: false },
                { text: "1/23.", isPrimary: true },
              ]}
            />
          </MouseParallaxChild>
          <MouseParallaxChild className="absolute right-[-5%] top-[53%]">
            <Image src={rightImage} alt="right" width={645} height={968} className="w-[240px]" />
          </MouseParallaxChild>
          <MouseParallaxChild className="absolute right-[8%] top-[58%] opacity-100" factorX={0.5} factorY={0.5}>
            <PostCard
              imageSrc={aidan}
              name="Aidan Cullen"
              professionString="Photographer, Director"
              textParts={[
                { text: "Creative Producer", isPrimary: true },
                { text: "needed for an", isPrimary: false },
                { text: "event.", isPrimary: true },
              ]}
            />
          </MouseParallaxChild>
          <MouseParallaxChild className="absolute right-[-5%] top-[20%] opacity-90" factorX={1.5} factorY={1.5}>
            <PostCard
              imageSrc={pizzaslime}
              scale={0.8}
              name="Pizzaslime"
              textParts={[
                { text: "Full-time", isPrimary: false },
                { text: "Graphic Designer", isPrimary: true },
                { text: "needed in", isPrimary: false },
                { text: "Los Angeles, CA.", isPrimary: true },
              ]}
            />
          </MouseParallaxChild>
          <div className="absolute left-1/2 top-1/2 flex w-full max-w-[500px] -translate-x-1/2 -translate-y-1/2 flex-col items-center gap-y-14 text-center text-marketing-primary-light lg:max-w-[730px] dark:text-marketing-primary-dark">
            <Text variant="h2">Connecting Leading Brands with Top Creative Talent</Text>
            <Link href="/sign-up" className="flex flex-row items-center gap-[15px] transition-all">
              <Text className="text-marketing-secondary">Hire the perfect</Text>
              <div
                style={{
                  boxShadow:
                    "0px 8px 40px 0px rgba(229, 150, 215, 0.15), 19px 10px 18.9px 0px rgba(100, 10, 217, 0.08)",
                }}
                className="flex h-[38px] items-center rounded-lg border border-marketing-secondary bg-marketing-background-1-light px-[10px] text-center text-marketing-primary-light transition-all dark:bg-marketing-background-1-dark dark:text-marketing-primary-dark">
                <WordCycler />
              </div>
              <Text className="text-marketing-secondary">here</Text>
              <ArrowRightIcon className="size-6 stroke-marketing-primary-light dark:stroke-marketing-primary-dark" />
            </Link>
          </div>
        </MouseParallaxContainer>
      </section>
      <section className="relative block h-[100vh] w-full sm:hidden">
        <Image
          src={leftImage}
          alt="left"
          width={645}
          height={805}
          className="absolute left-[-40px] top-0 w-[160px] object-left"
        />
        <Image
          src={rightImage}
          alt="right"
          width={645}
          height={968}
          className="absolute bottom-[40px] right-[-20px] w-[140px]"
        />

        <div className="absolute bottom-[18%] left-[-20%] w-[240px] scale-[0.8]">
          <PostCard
            imageSrc={fourtwofour}
            name="424"
            textParts={[
              { text: "Photographer", isPrimary: true },
              { text: "needed for a", isPrimary: false },
              { text: "lookbook", isPrimary: true },
              { text: "in", isPrimary: false },
              { text: "Paris", isPrimary: true },
              { text: "on", isPrimary: false },
              { text: "1/23.", isPrimary: true },
            ]}
          />
        </div>
        <div className="absolute bottom-[0%] right-[40px] w-[240px] scale-75">
          <PostCard
            imageSrc={aidan}
            name="Aidan Cullen"
            professionString="Photographer, Director"
            textParts={[
              { text: "Creative Producer", isPrimary: true },
              { text: "needed for an", isPrimary: false },
              { text: "event.", isPrimary: true },
            ]}
          />
        </div>
        <div className="absolute left-1/2 top-[44%] flex w-full max-w-[730px] -translate-x-1/2 -translate-y-1/2 flex-col items-center gap-y-14 px-5 text-center text-marketing-primary-light dark:text-marketing-primary-dark">
          <Text variant="h2">Connecting Leading Brands with Top Creative Talent</Text>
          <Link
            href="/sign-up"
            className="flex w-screen flex-row items-center justify-center gap-[15px] transition-all">
            <Text className="text-marketing-secondary">Hire the perfect</Text>
            <div
              style={{
                boxShadow: "0px 8px 40px 0px rgba(229, 150, 215, 0.15), 19px 10px 18.9px 0px rgba(100, 10, 217, 0.08)",
              }}
              className="flex h-[38px] items-center rounded-lg border border-marketing-secondary bg-marketing-background-1-light px-[10px] text-center text-marketing-primary-light transition-all dark:bg-marketing-background-1-dark dark:text-marketing-primary-dark">
              <WordCycler />
            </div>
            <ArrowRightIcon className="size-6 stroke-marketing-primary-light dark:stroke-marketing-primary-dark" />
          </Link>
        </div>
      </section>
    </>
  )
}

interface PostCardProps {
  imageSrc: StaticImageData
  name: string
  professionString?: string
  textParts: { text: string; isPrimary: boolean }[]
  scale?: number
}

const PostCard: React.FC<PostCardProps> = ({ imageSrc, name, textParts, professionString, scale = 1 }) => {
  return (
    <div className="relative">
      <div
        style={{
          scale: scale,
        }}
        className="relative flex w-full max-w-[320px] flex-col gap-y-3 rounded-xl border border-marketing-background-2-light bg-marketing-background-1-light p-6 drop-shadow-lg sm:scale-75 xl:scale-100 dark:border-none dark:bg-marketing-background-2-dark">
        <div className="flex flex-row items-center gap-x-2">
          <Image src={imageSrc} alt={name} width={112} height={112} className="size-7" />
          <div className="flex flex-col">
            <Text className="text-marketing-primary-light dark:text-marketing-primary-dark">{name}</Text>
            {professionString ? <Text className="text-marketing-secondary">{professionString}</Text> : null}
          </div>
        </div>
        <Text>
          {textParts.map((part, index) => (
            <Text
              element="span"
              key={index}
              className={
                part.isPrimary
                  ? "text-marketing-primary-light dark:text-marketing-primary-dark"
                  : "text-marketing-secondary"
              }>
              {part.text}{" "}
            </Text>
          ))}
        </Text>
      </div>
      <div
        style={{
          scale,
        }}
        className="absolute left-0 top-0 h-full w-full rounded-xl sm:scale-75 xl:scale-100 dark:bg-marketing-background-1-dark/20"
      />
    </div>
  )
}
